export const getObjectByPath = (obj, path) =>
  path.reduce((accm, key) => (accm = accm[key] ? accm[key] : accm), obj);

export const hasTypeParams = (type) =>
  type && type.typeParams && type.typeParams.length > 0;

export const hasMatchUrlFormatAndKey = (node, key) =>
  node && node.data && node.data.urlFormat === key;
